import { Input, type InputProps } from "antd";
import clsx from "clsx";
import "./BInput.scss";

const BInput = ({ className, ...props }: InputProps) => (
  <Input className={clsx("b-input", className)} {...props} />
);

export default BInput;
